import { render, staticRenderFns } from "./GeneratedItem.vue?vue&type=template&id=ae885c74&scoped=true"
import script from "./GeneratedItem.vue?vue&type=script&lang=js"
export * from "./GeneratedItem.vue?vue&type=script&lang=js"
import style0 from "./GeneratedItem.vue?vue&type=style&index=0&id=ae885c74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae885c74",
  null
  
)

export default component.exports